import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    minHeight: 'calc(100vh - 66px)',
    backgroundColor: Colors.lightGray,
  },
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingTop: '1rem',
    gap: '1.5rem',
    width: '90vw',
    height: '100%',
    margin: '1rem',
    fontSize: '1.5rem',
    flexWrap: 'wrap',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    paddingTop: '1rem',
    gap: '0.5rem',
    '& > p': {
      maxWidth: '75%',
      textAlign: 'justify',
    },
  },
  
  leftSide: {
    width: 'calc(70% - 4rem)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    gap: '1.5rem',
    '@media (max-width: 1500px)': {
      width: '100%',
    },
  },
  
  justified: {
    fontSize: '16px',
    textAlign: 'justify',
  },
  
}))

export default styles
